// Response-envelope helper for the Service Desk service layer.
//
// The torre-de-control-api wraps every payload in `{ meta, data }`, and the
// serviceDesk controller additionally nests its handler payload as
// `{ message, data }` — so the real payload lives at `res.data.data.data`.
// Older/alternate shapes (pageResponse, or a future backend) expose it at
// `res.data.data`. `unwrap` reads the deep level first and falls back, so the
// client works against either backend shape (deployed dev vs. local emulator).
//
// Kept dependency-free (no axios/firebase imports) so it is unit-testable in
// isolation — see serviceDeskService.unwrap.test.ts.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const unwrap = (res: any): any => res?.data?.data?.data ?? res?.data?.data;

/**
 * Mensaje de un error de la API. El errorHandler del backend lo pone en
 * `meta.message`; se contemplan las formas heredadas por si acaso.
 *
 * Vive aquí, y no en el hook que lo estrenó, justamente porque este módulo no
 * arrastra dependencias: así lo puede usar también el panel de error de las
 * secciones sin cargar stores (y con ellos firebase) en las pruebas.
 */
export function apiErrorMessage(err: unknown, fallback = ""): string {
  const data = (
    err as {
      response?: {
        data?: {
          meta?: { message?: unknown };
          data?: { message?: unknown };
          message?: unknown;
        };
      };
    }
  )?.response?.data;
  const msg = data?.meta?.message ?? data?.data?.message ?? data?.message;
  return typeof msg === "string" && msg ? msg : fallback;
}
